import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard that allows access only when the user is authenticated.
 * Redirects to sign-in with returnUrl so the user can be sent back after login.
 */
export const authGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  const returnUrl = state.url || '/marketplace';
  router.navigate(['/signin'], { queryParams: { returnUrl } });
  return false;
};
